var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuoteMarks = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlSpace: "preserve",
  style: {
    enableBackground: "new 0 0 103.21 74.21"
  },
  viewBox: "0 0 103.21 74.21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M-.005 73.494 73.49-.002l.707.707L.702 74.201zm28.999 0L102.49-.002l.708.707-73.496 73.496z",
  fill: "#231f20"
})));
export { SvgQuoteMarks as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNDYxNjc2YWIzZTc3NmFjNzE1ZTRhNGMyOWJhNzRmNGEuc3ZnIjs=";